// 账户中心
export default [

  {
    path: '/account',
    name: '账户中心',
    component: () => import(/* webpackChunkName: 'account' */ '@/views/account/mainPage.vue'),
    children: [
      {
        path: 'index',
        name: '账户中心',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/index.vue')
      },
      {
        path: 'baseInfo',
        name: '游客基本信息',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/baseInfo.vue')
      },
      {
        path: 'baseInfoInstitution',
        name: '企业基本信息',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/institutional/baseInfo.vue')
      },
      {
        path: 'baseInfoPerson',
        name: '个人基本信息',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/personal/baseInfo.vue')
      },
      {
        path: 'quoteManage',
        name: '股权份额管理',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/institutional/quoteManage.vue')
      },
      {
        path: 'fundManage',
        name: '股权份额管理',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/institutional/fundManage.vue')
      },
      {
        path: 'appointPerson',
        name: '洽谈人管理',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/institutional/appointPerson.vue')
      },
      {
        path: 'appointPersonDetail/:id',
        name: '洽谈人详情',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/institutional/appointPersonDetail.vue')
      },
      {
        path: 'expert',
        name: '专家管理',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/institutional/expert.vue')
      },
      {
        path: 'favorite',
        name: '我的关注',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/favorite.vue')
      },
      {
        path: 'appointment',
        name: '我的预约',
        component: () => import(/* webpackChunkName: "wap-main-page" */ '@/views/account/appointment.vue')
      }
    ]
  },
  {
    path: '/login',
    name: '登录',
    component: () => import(/* webpackChunkName: 'account' */ '@/views/account/login.vue')
  },
  {
    path: '/register',
    name: '注册',
    component: () => import(/* webpackChunkName: 'account' */ '@/views/account/register.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/moudles/accountRouter.js